import React, { Component, Fragment } from 'react';
import {
  imageBasePath,
  isDevelopment,
  dualPedigreeMode,
  dualPedigreeLaunchOnDev,
  scaleDownDesktopIcon,
  imgPrinterIconHash
} from '../../library/constants';
import './index.css';
import {
  isMobilePhone,
  isMobileTablet,
  isAndroidTablet,
} from '../../library/calc';

class SwitchTree extends Component {

  state = {opacity: .7}

  // setOpacity(bool){
  //   this.setState({
  //     opacity: bool === true ? 1 : .7
  //   });
  // }

  render () {

    const {
      switchTree,
      switchTreeTo,
      // isFanChart,
      // isPedigree,
      chartType,
      setShowSwitchOtherIcons,
      showSwitchOtherIcons,
      toggleNavigationalPanel,
    } = this.props;

    let desktopLength = 60;
    let mobileLength = 46;

    const genericStyles = {
      scale: scaleDownDesktopIcon,
      width: `${(!isMobilePhone() ? desktopLength: mobileLength)}px`,
      height: `${(!isMobilePhone() ? desktopLength: mobileLength)}px`,
      right: `${(!isMobilePhone()? 50: 15)}px`,
      bottom: `${(!isMobilePhone() ? 36: 17)}px`,
      backgroundRepeat: `no-repeat`,
      backgroundSize: `${(!isMobilePhone() ? 55: 43)}px`,
      backgroundColor: 'white',
      backgroundPosition: '2px 2px',
      border: '1px solid #C0C0C0',
      position: 'absolute',
      opacity: `${this.state.opacity}`,
      cursor: 'pointer',
      MozBoxShadow: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
      webKitboxShadow: '0 4px 8px 0 rgba(0,0,0,0.12),  0 2px 4px 0 rgba(0,0,0,0.08)',
      boxShadow: '0 4px 8px 0 rgba(0,0,0,0.12),  0 2px 4px 0 rgba(0,0,0,0.08)',
    }

    let icon = undefined;

    if(isDevelopment){
      icon = (this.props.isPedigreeDev ? 'defaulttree': 'pedigreetree');
    } else{
      icon = (this.props.isPedigree ? 'defaulttree': 'pedigreetree');
    }

    let switchTreeStyle = {
      backgroundImage: `url(${imageBasePath}${icon}.svg?${this.props.clearImgCache})`,
      ...genericStyles,
    };

    let verticalSpacing = 60;
    let bottom = ( showSwitchOtherIcons ? 132: 37);
    let center = bottom + verticalSpacing;
    let top = center + verticalSpacing;

    if(isMobilePhone()){
      verticalSpacing = 60;
      bottom = ( showSwitchOtherIcons ? 90: 20);
      center = bottom + verticalSpacing;
      top = center + verticalSpacing;
    }

    let orderHash = undefined;

    if( chartType === 'fan'){
      orderHash = {
        'fan': bottom,
        'default': center,
        'horizontal': top
      }
    }

    if( chartType === 'default'){
      orderHash = {
        'default': bottom,
        'fan': center,
        'horizontal': top
      }
    }

    if( chartType === 'horizontal'){
      orderHash = {
        'horizontal': bottom,
        'fan': center,
        'default': top,
      }
    }

    const switchIconArr = [];
    for( let chartType in orderHash){

      let adaptedStyle = switchTreeStyle;
      if(chartType === 'fan') adaptedStyle = {...switchTreeStyle, backgroundPosition: '2px 5px',}

      switchIconArr.push(
        <div
          id={`switchTreeIcon-${chartType}`}
          key={`switchTreeIcon-${chartType}`}
          className={'switchTreeIcons'}
          style={{...adaptedStyle,
            bottom: `${orderHash[chartType]}px`,
            backgroundImage: `url(${imageBasePath}${imgPrinterIconHash[chartType]}.svg?${this.props.clearImgCache})`,
            visibility: (showSwitchOtherIcons && chartType !== this.props.chartType) ||
                        (chartType === this.props.chartType) ? 'visible': 'hidden'
          }}

          onClick={
            ()=>{
              if(isDualPedigreeFeature()) {
                const href = `/family-tree/index/${this.props.focusPrId}`;
                window.document.location = href;
                return false;
              }

              if( chartType === this.props.chartType && showSwitchOtherIcons){
                // this.setOpacity(false)
                setShowSwitchOtherIcons(false)
              } else if( chartType === this.props.chartType && !showSwitchOtherIcons){
                if( chartType === 'default'){
                  toggleNavigationalPanel({direction: 'down', callback: ()=>{
                    setShowSwitchOtherIcons(true);
                  }})
                } else {
                  setShowSwitchOtherIcons(true);
                }
              } else {
                switchTreeTo({chart_type: chartType});
              }

            }
          }
          >
        </div>
      )
    }

    if( isAndroidTablet() ) {

      let side  = 38;

      switchTreeStyle = {
        ...switchTreeStyle,
        // top: `${ 300 }px`,
        bottom: `${(!isMobilePhone() ? 37: 0)}px`,
        width: `${ side }px`,
        height: `${ side }px`,
        backgroundSize: `${ side - 5 }px`,
      };
    }

    const isDualPedigreeFeature = () => {
      return dualPedigreeMode || dualPedigreeLaunchOnDev;
    };

    if( dualPedigreeMode && isMobileTablet()) return null;

    // if(isMobilePhone()){
        // return (
        //   <div >
        //     <div
        //       id={'switchTreeIcon'}
        //       style={switchTreeStyle}
        //       onClick={
        //         ()=>{
        //           if(isDualPedigreeFeature()) {
        //             const href = `/family-tree/index/${this.props.focusPrId}`;
        //             window.document.location = href;
        //             return false;
        //           }
        //           switchTree();
        //         }
        //       }
        //       >
        //     </div>
        //   </div>
        // );
    // } else {

      if( !showSwitchOtherIcons)   {
        return (
          <div style={{
          }}>{switchIconArr}
          </div>);}
      else {
        return (
          <Fragment>
                <div id='blurScreen'
                  onClick={
                    ()=>{setShowSwitchOtherIcons(false)}
                  }
                  style={{
                    display: 'block',
                    width: `${window.innerWidth}px`,
                    height: `${window.innerHeight + ( isMobilePhone() ? 0: 0)}px`,
                    position: 'relative',
                    // top: '0px',
                    top: ( isMobilePhone() ?'-10px':'0px'),
                    zIndex: 1,
                    background: 'rgba(0, 0, 0, 0.2)', // white with 50% opacity
                    backdropFilter: 'blur(5px)', // blur the background
                    WebkitBackdropFilter: 'blur(2px)' // for Safari support
                  }}
                >
                <div style={{
                }}>{switchIconArr}
                </div>

              </div>
            </Fragment>
          );
      }
    // }

  }
}

export default SwitchTree;
